
let userType = {
    value: '',
    statusFlag: true,
    compFile: '',
    historyStageId: 0,
    deductionFlag: true,
    deductionValue: '',
    checklistFlag: false,
    detailAnalysisFlag: false,
    DAEnableFlag: true,
    salaryInitializeFlag: true,
    houseInitializeFlag: true,
    businessInitializeFlag: true,
    capitalInitializeFlag: true,
    otherInitializeFlag: true,
    agricultureInitializeFlag: true,
    donationInitializeFlag: true,
}

export { userType };